// eslint-disable-next-line no-restricted-imports
import { Settings } from "luxon";
import { appDateTimeZone } from "../schema/appDateTimeZone.js";

Settings.throwOnInvalid = true;
Settings.defaultZone = appDateTimeZone;

declare module "luxon" {
	interface TSSettings {
		throwOnInvalid: true;
	}
}

// eslint-disable-next-line no-restricted-imports
export * from "luxon";
